import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Components
import Core from '../Core';
import Authentication from '../Components/Authentication';
import CharacterCreation from '../Components/CharacterCreation/CharacterCreation';
import LoadingSpinner from '../Components/Common/LoadingSpinner';
import { log } from "../Helpers/logger";

const AppRoutes = () => {
  const user = useSelector(state => state.user);
  // Check for hero in both locations for backward compatibility
  const hero = useSelector(state => state.hero?.hero || state.user?.gameData?.hero);
  const [isInitialized, setIsInitialized] = useState(false);
  const location = useLocation();
  
  // Debug log the full user state
  log.auth.log('Full user state:', user);
  log.auth.log('Hero from state:', hero);

  // Check if user is authenticated on initial load
  useEffect(() => {
    log.auth.log('AppRoutes - Checking authentication status');
    log.auth.log('User state:', user);
    log.auth.log('Hero state:', hero);
    
    // Small delay to ensure Redux state is properly hydrated
    const timer = setTimeout(() => {
      log.auth.log('AppRoutes - Initialization complete');
      setIsInitialized(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, [user, hero]);

  // Show loading spinner while initializing
  if (!isInitialized) {
    return <LoadingSpinner />;
  }

  // If user is not authenticated, show login page
  if (!user?.isAuthenticated) {
    log.auth.log('AppRoutes - User not authenticated, redirecting to login');
    return (
      <Routes>
        <Route path="/login" element={<Authentication />} />
        <Route path="*" element={<Navigate to="/login" state={{ from: location }} replace />} />
      </Routes>
    );
  }

  // If user is authenticated but has no character, show character creation
  if (!hero) {
    log.auth.log('AppRoutes - No character found, showing character creation');
    log.auth.log('User hasCharacter flag:', user?.hasCharacter);
    log.auth.log('User gameData:', user?.gameData);
    
    // If we're already on the character creation page, just render it
    if (location.pathname === '/character-creation') {
      return <CharacterCreation />;
    }
    
    // Otherwise, redirect to character creation
    return (
      <Routes>
        <Route path="/character-creation" element={<CharacterCreation />} />
        <Route path="*" element={<Navigate to="/character-creation" replace />} />
      </Routes>
    );
  }

  // If user is authenticated and has a character, show the game
  log.auth.log('AppRoutes - User authenticated with character, showing game');
  return (
    <Routes>
      <Route path="/game" element={<Core />} />
      <Route path="*" element={<Navigate to="/game" replace />} />
    </Routes>
  );
};

export default AppRoutes;
